export const iconFontAwesomeBuildingsBuildingShield = (
	<i className="fa-solid fa-building-shield"></i>
);
